import { render, staticRenderFns } from "./UnSearchDetail.vue?vue&type=template&id=afc901cc&scoped=true&"
import script from "./UnSearchDetail.vue?vue&type=script&lang=js&"
export * from "./UnSearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./UnSearchDetail.vue?vue&type=style&index=0&id=afc901cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc901cc",
  null
  
)

export default component.exports